import React from 'react';
export var LocationsContext = /*#__PURE__*/React.createContext({
  locations: [],
  activeLocation: null,
  setActiveLocation: null,
  loaded: false
});
export var LocationsContextProvider = LocationsContext.Provider;